export default {
	homeGym: {}
};
